// removed by extract-text-webpack-plugin
module.exports = {"recentConversations":"recentConversations__3q3dlVdGNqOI"};